/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import { SubmitButton, CancelButton } from '../../Res/BaseButton';
import { RespDepartment } from '../../../../item/ItemDepartment';
import { CheckDisable } from '../../Res/BaseInput';
import { ContentBox } from '../../Content/ContentBox';
import { AdminDepartmentContent } from './AdminDepartmentContent';


export function AdminDepartmentEdit ({department, cancel, list}) {
  const[mDepartment, setDepartment] = useState(department)
  const[departmentName, setDepartmentName] = useState(department.departmentName)
  const[managerDepartmentId, setManagerDepartmentId] = useState(department.managerDepartmentId)
  const[departmentList, setDepartmentList] = useState(list)
  const [isDisable, setisDisable] = useState(department.isDisable)


  var title = '公司 - 編輯'
  var title_tools = ''
  var content = <DepartmentEditContent list={list} department={mDepartment} sn={setDepartmentName} sm={setManagerDepartmentId} sd={setisDisable} />
  var footer =
    <div class="row">
      <div class="col-sm-3 col-sm-offset-9">
        <SubmitButton action={toEdit} isRight={true} />
        <CancelButton action={cancel} isRight={true} />
      </div>
    </div>

  useEffect(()=>{
    console.log(department)
    if(mDepartment !== department){
      setDepartment(department)
      setDepartmentName(department.departmentName)
      setManagerDepartmentId(department.managerDepartmentId)
      setisDisable(department.isDisable)
    }
  },[mDepartment, department])

  useEffect(()=>{
    if(departmentList !== list){
      setDepartmentList(list)
    }
  },[departmentList, list])


  function toEdit(){
    if(departmentName !== ""){
      var mRespDepartment = new RespDepartment({
        departmentId: mDepartment.departmentId,
        departmentName,
        managerDepartmentId,
        isDisable
      })
      apiCompany.departmentEdit({
        mRespDepartment, 
        success: (obj)=>{
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '修改成功',
          }).then(function() {
            setDepartmentName("")
            setManagerDepartmentId("")
            cancel(false)
            //window.history.replace("/ManagerList");
          })
        },
        failure:()=>{

        }
      })
    }else{
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '公司名稱 不得為空',
      })
    }
  }

    return (    
      <ContentBox title={title} title_tools={title_tools} content={content} footer={footer}  hasDrawer={true} />
    )
    /*
      <section className="content">
  
        <div className="box box-default">
          <div className="box-header with-border">
            <h3 className="box-title">部門 - 編輯</h3>
            <div className="box-tools pull-right">
              <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>
            </div>
          </div>
          <div className="box-header">
          </div>
          <div className="box-body padding">
            
          <div className="row">
            <div className="col-sm-6">
                <ItemDepartmentName departmentName={departmentName} setDepartmentName={setDepartmentName} />
            </div>
            <div className="col-sm-6">
                <ItemDepartmenListSelect departmentList={departmentList} managerDepartmentId={managerDepartmentId} setManagerDepartmentId={setManagerDepartmentId} />
            </div>
          </div>
            <div className="row">
              <div className="col-sm-6">
                  <div className="row">
                    <div className="col-sm-12">                        
                      <div className="custom-control custom-switch">
                        <input type="checkbox" checked={isDisable} onChange={e=>setisDisable(e.target.checked?1:0)} />
                        <label className="custom-control-label" htmlFor="customSwitches">是否停用</label>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div className="box-footer">
              <button type="submit" className="btn btn-default" onClick={e=>cancel(false)}>取消</button>
              <button type="submit" className="btn btn-info pull-right" onClick={toEdit}>確定</button>
            </div>
        </div>

      </section>
    */
}

export function DepartmentEditContent({list, department, sn, sm, sd}){
  const[mDepartment, setDepartment] = useState(department)
  const [isDisable, setisDisable] = useState(department.isDisable)

  useEffect(() => {
    if (department !==undefined && mDepartment !== department) {
      setDepartment(department)
      setisDisable(department.isDisable)
    }
  },[department])

  return (
    <>
      <AdminDepartmentContent list={list} department={mDepartment} sn={sn} sm={sm}  />
      <CheckDisable obj={mDepartment} isDisable={isDisable} sd={sd} />
    </>
  )
}